import { createFileRoute } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useContacts } from '@/api/hooks/useContacts'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import { EmptyState } from '@/components/molecules/empty-state'
import PageHeader from '@/components/molecules/page-header'
import { ContactDialog } from '@/components/organisms/contact-dialog'
import ContactsTable from '@/components/organisms/contacts-table'
import { Button } from '@/components/ui/button'
import { useSubscription } from '@/contexts/subscription-context'
import { useIndividuals } from '@/hooks/useIndividuals'

export const Route = createFileRoute('/_authenticated/contacts/')({
  component: ContactsPage,
})

function ContactsPage() {
  const { individualQuery, selectedIndividualId } = useIndividuals()
  const { t } = useTranslation()
  const { data: contacts = [], isLoading } = useContacts(selectedIndividualId)
  const [createOpen, setCreateOpen] = useState(false)
  const { isReadOnly } = useSubscription()

  return (
    <div className="space-y-8 z-10">
      <PageHeader
        body={t('contactsPage.header.description')}
        heading={t('contactsPage.header.title')}
      >
        {contacts.length > 0 && (
          <Button disabled={isReadOnly} onClick={() => setCreateOpen(true)}>
            <PlusIcon />
            {t('contactsPage.header.createContactButton')}
          </Button>
        )}
      </PageHeader>
      <StateSwitcher
        emptyState={
          <EmptyState
            body={t('contactsPage.emptyState.description')}
            ctaText={t('contactsPage.header.createContactButton')}
            ctaType="create-content"
            heading={t('contactsPage.emptyState.title')}
            // EmptyState hides its CTA when no handler is given — nothing to offer
            // while contacts can't be created.
            onClickCta={isReadOnly ? undefined : () => setCreateOpen(true)}
          />
        }
        isEmpty={contacts.length === 0}
        isLoading={individualQuery.isLoading || isLoading}
      >
        <ContactsTable contacts={contacts} />
      </StateSwitcher>
      <ContactDialog onOpenChange={setCreateOpen} open={createOpen} />
    </div>
  )
}
